import { DetailsList, IColumn, SelectionMode, TooltipHost } from '@fluentui/react';
import { FC, useMemo } from 'react';
import { IWaitingConversation } from '../../models/reports.internal';
import useSortedListItems from '../../shared/hooks/useSortedListItems';
import ElapsedTimeTooltipHost from './ElapsedTimeTooltipHost';

const WaitingConversations: FC<{ items: IWaitingConversation[] }> = ({ items }) => {
  const { sortedItems, columnSortProps } = useSortedListItems(items, 'position');

  const columns = useMemo<IColumn[]>(
    () => [
      {
        key: 'position',
        name: 'Position',
        minWidth: 70,
        maxWidth: 70,
        onRender: ({ position }: IWaitingConversation) => {
          const pos = position !== null ? (position + 1).toString() : 'n/a';
          return <TooltipHost content={pos}>{pos}</TooltipHost>;
        },
        ...columnSortProps('position'),
      },
      {
        key: 'waitTime',
        name: 'Wait time',
        minWidth: 80,
        maxWidth: 80,
        onRender: ({ waitStartTime }: IWaitingConversation) => <ElapsedTimeTooltipHost timeStart={waitStartTime} />,
        ...columnSortProps('waitStartTime'),
      },
      {
        key: 'customerName',
        name: 'Customer name',
        minWidth: 150,
        onRender: ({ customer }: IWaitingConversation) => {
          const name = customer?.name ?? 'Unknown';
          return <TooltipHost content={name}>{name}</TooltipHost>;
        },
        ...columnSortProps({ key: 'customerName', selector: i => i.customer ? i.customer.name : null }),
      },
      {
        key: 'customerIdentifier',
        name: 'Customer identifier',
        minWidth: 150,
        maxWidth: 150,
        onRender: ({ customer }: IWaitingConversation) => {
          const identifier = customer?.identifier ?? '';
          return <TooltipHost content={identifier}>{identifier}</TooltipHost>;
        },
        ...columnSortProps({ key: 'customerIdentifier', selector: i => i.customer ? i.customer.identifier : null }),
      },
      {
        key: 'type',
        name: 'Type',
        minWidth: 100,
        maxWidth: 100,
        onRender: ({ virtualConversationType }: IWaitingConversation) => {
          const type = virtualConversationType ?? 'Inbound';
          return <TooltipHost content={type}>{type}</TooltipHost>;
        },
        ...columnSortProps('virtualConversationType'),
      },
    ],
    [columnSortProps],
  );

  return (
    <DetailsList
      selectionMode={SelectionMode.none}
      items={sortedItems}
      columns={columns}
      onRenderDetailsFooter={() => items.length === 0 ? <div style={{ textAlign: 'center' }}>No conversations to show</div> : <span />}
      styles={{ root: { minWidth: '960px !important', height: '600px !important' } }}
    />
  );
};

export default WaitingConversations;